export const sortTableItems = (itemsArray = [], sortConfig = {}) => {
  if (!Array.isArray(itemsArray) || !sortConfig?.key) return itemsArray || [];

  const { key, direction } = sortConfig;
  const dir = direction === 'desc' ? -1 : 1;

  const dateKeys = new Set([
    'created_at',
    'last_scanned_at',
    'started_at',
    'updated_at',
    'queued_at',
    'regenerated_at',
  ]);

  const statusOrder = {
    'Not Started': 1,
    pending: 1,
    Draft: 1,
    'In Progress': 2,
    in_progress: 2,
    RUNNING: 2,
    Scanned: 3,
    Passed: 3,
    completed: 3,
    COMPLETED: 3,
    Failed: 4,
    FAILED: 4,
    failed: 4,
  };

  const getValue = (item) => {
    // Special: sort by testCasesTotal, treat unsupported page types as 0
    if (key === 'testCasesTotal') {
      const isUnsupported =
        Array.isArray(item?.pageTypes) && item.pageTypes[0]?.type === 'Unknown';
      return isUnsupported ? 0 : Number(item?.testCasesTotal) || 0;
    }

    // Dates as timestamps
    if (dateKeys.has(key)) {
      return item?.[key] ? new Date(item[key]).getTime() : 0;
    }

    // Status order mapping
    if (key === 'status') {
      return statusOrder[item?.status] ?? 0;
    }

    const v = item?.[key];
    if (typeof v === 'number') return v;
    if (typeof v === 'string') return v.toLowerCase();
    return v ?? '';
  };

  const compare = (a, b) => {
    const aVal = getValue(a);
    const bVal = getValue(b);

    const aIsNum = typeof aVal === 'number';
    const bIsNum = typeof bVal === 'number';

    if (aIsNum && bIsNum) return (aVal - bVal) * dir;

    // Fallback to string compare
    const aStr = (aVal ?? '').toString();
    const bStr = (bVal ?? '').toString();
    return aStr.localeCompare(bStr) * dir;
  };

  return [...itemsArray].sort(compare);
};
 
